import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';

const Cursor = styled.div`
    width: 10px;
    height: 10px;
    background: linear-gradient(to bottom, #5101e3, #8300e7, #a900eb, #cc00ee, #eb00f0);
    border-radius: 50%;
    position: fixed;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 9999;
    box-shadow: 0 0 8px 7px violet; /* Neon glow effect */
`;

const expandEffect = keyframes`
    from {
        width: 10px;
        height: 10px;
        opacity: 1;
    }
    to {
        width: 100px;
        height: 100px;
        opacity: 0;
    }
`;

const ClickEffect = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: fixed;
    transform: translate(-50%, -50%);
    background: linear-gradient(to bottom, #5101e3, #8300e7, #a900eb, #cc00ee, #eb00f0);
    pointer-events: none;
    z-index: 9998;
    animation: ${expandEffect} 0.5s ease-out forwards;
`;

const TrailDot = styled.div`
    width: 6px;
    height: 6px;
    background: violet; // Or any color/style you prefer
    border-radius: 50%;
    position: fixed;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 9997; // Below the main cursor
`;

const CustomCursor = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [clicked, setClicked] = useState(false);
    const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });
    const [trail, setTrail] = useState([]); // New state for the trail
    const timerRef = useRef(null);

    useEffect(() => {
        
        const updateCursor = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
            if (!timerRef.current) {
                timerRef.current = setTimeout(() => {
                    setTrail((prev) => [...prev.slice(-10), { x: e.clientX, y: e.clientY }]);
                    timerRef.current = null;
                }, 10); // Increase the delay, e.g., 200 milliseconds
            }
            
        };
    
        document.addEventListener('mousemove', updateCursor);
    
        const handleMouseDown = (e) => {
            setClicked(true);
            setClickPosition({ x: e.clientX, y: e.clientY });
        };
    
        const handleMouseUp = () => {
            setClicked(false);
        };
    
        document.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('mouseup', handleMouseUp);
    
        return () => {
            clearTimeout(timerRef.current);
            document.removeEventListener('mousemove', updateCursor);
            document.removeEventListener('mousedown', handleMouseDown);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);
    

    
    

    return (
        <>
            <Cursor style={{ left: `${position.x}px`, top: `${position.y}px` }} />
            {trail.map((dot, index) => (
                <TrailDot key={index} style={{ left: `${dot.x}px`, top: `${dot.y}px` }} />
            ))}
            {clicked && (
                <ClickEffect style={{ left: `${clickPosition.x}px`, top: `${clickPosition.y}px` }} />
            )}
        </>
    );
            };

export default CustomCursor;
